import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import url from 'url'
import mapDispatchers from './utilities/mapDispatchers'
import getNormalisedParameters from './utilities/getNormalisedParameters'
import styles from './ImageDownload.icss'

class ImageDownload extends React.Component {
	static getDerivedStateFromProps(props) {
		const parsedSearch = getNormalisedParameters(props.location.search)
		const src = parsedSearch.src
		const imgUrl = url.parse(src)
		const result = {}
		if (imgUrl.host === 'firebasestorage.googleapis.com' && imgUrl.slashes === true) {
			result.src = src
		}
		return result
	}

	constructor(props) {
		super(props)

		this.state = {}
	}

	componentDidMount() {
		this.props.appShowBottomBar(false)
		this.props.appShowBottomNavBar(false)
	}


	render() {
		return (
			<div className={styles.wrapper}>
				<section className={styles.imageSurround}>
					<img className={styles.image} alt="kitfit" src={this.state.src} />
				</section>
				<section className={styles.pagePadding}>
					<p>{this.context.translate('Long press on the image (press and hold) then choose “save” to add to your photos')}</p>
				</section>
			</div>
		)
	}
}

ImageDownload.contextTypes = {
	translate: PropTypes.func
}

ImageDownload.propTypes = {
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	location: PropTypes.shape({
		search: PropTypes.string
	}).isRequired
}

ImageDownload.defaultProps = {
}

export default connect(
	null,
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['appShowBottomBar', 'appShowBottomNavBar'])
)(ImageDownload)



// WEBPACK FOOTER //
// ./src/ImageDownload.jsx